import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchAdminClientApplications = ({ options = {} }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/client_applications', reqArgs: options })
    handleCall(req, resolve, reject, true, options)
  })
